import {
  Button as AntButton,
  Modal,
  Select,
  Table,
  TableColumnsType,
} from 'antd';
import Pagination from '../../../../../components/Pagination';
import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import { ILevelUpStaticResponse } from '../../../../../models/semesters.model';
import Loader from '../../../../Loader';
import ErrorResponse from '../../../../ErrorResponse';
import useAxios from '../../../../../hooks/useAxios';
import ScoreStaticsTable from './ScoreStaticsTable';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../store/rootReducer';
import { getLevelUpStaticsData } from '../../../../../api/semesters.api';
import DownloadButton from '../../../../DownloadButton';
import exportTable from '../../../../../lib/exportTable';
import moment from 'moment';
import Item from 'antd/lib/list/Item';

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  levelUpCode: number | undefined;
  semesterCode: string | number;
}

const ScoreStaticsModal: FC<IProps> = ({
  visible,
  setVisible,
  levelUpCode,
  semesterCode,
}) => {
  const { t, i18n } = useTranslation();
  const { currentCampus } = useSelector((state: RootState) => state.auth);
  const [page, setPage] = useState(1);
  const {
    data: res,
    isLoading,
    error,
    execute,
  } = useAxios<ILevelUpStaticResponse>();
  useEffect(() => {
    execute(getLevelUpStaticsData(currentCampus, semesterCode));
  }, []);
  console.log('res', res);

  const levelupStaticColumns: TableColumnsType<object> = [
    {
      title: t('cbt.class.column2'), //레벨
      dataIndex: 'courseName',
      align: 'center',
    },
    {
      title: t('program.levelup.column1'),
      children: [
        {
          title: t('program.levelup.column2'),
          dataIndex: 'top10Percent',
          align: 'center',
          render: (value: any, record: any) => (value === 0 ? '-' : value),
        },
        {
          title: t('program.levelup.column3'),
          dataIndex: 'top20Percent',
          align: 'center',
          render: (value: any, record: any) => (value === 0 ? '-' : value),
        },
        {
          title: t('program.levelup.column4'),
          dataIndex: 'top30Percent',
          align: 'center',
          render: (value: any, record: any) => (value === 0 ? '-' : value),
        },
        {
          title: t('program.levelup.column5'),
          dataIndex: 'top40Percent',
          align: 'center',
          render: (value: any, record: any) => (value === 0 ? '-' : value),
        },
        {
          title: t('program.levelup.column6'),
          dataIndex: 'top50Percent',
          align: 'center',
          render: (value: any, record: any) => (value === 0 ? '-' : value),
        },
        {
          title: t('program.levelup.column7'),
          dataIndex: 'top60Percent',
          align: 'center',
          render: (value: any, record: any) => (value === 0 ? '-' : value),
        },
        {
          title: t('program.levelup.column8'),
          dataIndex: 'top70Percent',
          align: 'center',
          render: (value: any, record: any) => (value === 0 ? '-' : value),
        },
        {
          title: t('program.levelup.column9'),
          dataIndex: 'top80Percent',
          align: 'center',
          render: (value: any, record: any) => (value === 0 ? '-' : value),
        },
        {
          title: t('program.levelup.column10'),
          dataIndex: 'top90Percent',
          align: 'center',
          render: (value: any, record: any) => (value === 0 ? '-' : value),
        },
        {
          title: t('program.levelup.column11'),
          dataIndex: 'top100Percent',
          align: 'center',
          render: (value: any, record: any) => (value === 0 ? '-' : value),
        },
      ],
    },
    {
      title: t('program.levelup.column12'),
      dataIndex: 'averageScore',
      align: 'center',
      render: (value: any, record: any) => (value === 0 ? '-' : value),
    },
  ];
  const onExportExcel = () => {
    const _copyData = _.cloneDeep(res?.data);
    const _data = _copyData?.map((item: any) => ({
      ...item,
      top10Percent: item.top10Percent === 0 ? '-' : item.top10Percent,
      top20Percent: item.top20Percent === 0 ? '-' : item.top20Percent,
      top30Percent: item.top30Percent === 0 ? '-' : item.top30Percent,
      top40Percent: item.top40Percent === 0 ? '-' : item.top40Percent,
      top50Percent: item.top50Percent === 0 ? '-' : item.top50Percent,
      top60Percent: item.top60Percent === 0 ? '-' : item.top60Percent,
      top70Percent: item.top70Percent === 0 ? '-' : item.top70Percent,
      top80Percent: item.top80Percent === 0 ? '-' : item.top80Percent,
      top90Percent: item.top90Percent === 0 ? '-' : item.top90Percent,
      top100Percent: item.top100Percent === 0 ? '-' : item.top100Percent,
      averageScore: item.averageScore === 0 ? '-' : item.averageScore,
    }));
    _data?.forEach((item: any, idx: number) => {
      item.rowIdx = idx;
    });
    const currentDate = moment(new Date());
    exportTable(
      levelupStaticColumns,
      _data,
      `${t('program.semester.text14')}_(${currentDate.format('YYYYMMDD')})`,
      `${t('common.menu.statistics')}`,
      [20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20],
    );
  };
  return (
    <>
      <div>
        {isLoading && <Loader />}
        <ErrorResponse error={error} />
        <Modal
          title={t('program.semester.text14')}
          visible={visible}
          onCancel={() => setVisible(false)}
          width={1200}
          footer={[
            <div className='comm-btn__area justify-content-center'>
              <AntButton
                key="submit"
                className="btn-basic green"
                onClick={onExportExcel}
              >
                <i className='ic_excel'></i>
                <span>{t('program.semester.button10')}</span>
              </AntButton>
              <AntButton
                key="cancel"
                className="btn-basic gray"
                onClick={() => setVisible(false)}
              >
                {t('common.button.cancel')}
              </AntButton>
            </div>
          ]}
        >
          <div className="comm-bx__space">{t('program.semester.text15')}</div>
          <Table
            className='comm-table__area line-type mt-0'
            columns={levelupStaticColumns}
            dataSource={res?.data || []}
            pagination={{
              current: page,
              pageSize: 10,
            }}
          />
          <div className="comm-bx__space">
            <div className="common-paging center">
              <Pagination
                count={res?.data ? res?.data.length : 0}
                page={page}
                setPage={setPage}
                perPage={10}
              />
            </div>
          </div>
        </Modal>
      </div>
    </>
  );
};
export default ScoreStaticsModal;
